var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFailEnding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 426.667,
    height: 221.721,
    viewBox: "0 0 426.667 221.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_224",
    "data-name": "Rettangolo 224",
    width: 426.667,
    height: 216.242,
    fill: "#3f3d94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_350",
    "data-name": "Rettangolo 350",
    width: 312.239,
    height: 217.569,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Esito_negativo",
    "data-name": "Esito negativo",
    transform: "translate(39.214 -189.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_278",
    "data-name": "Raggruppa 278",
    transform: "translate(-39.214 189.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_277",
    "data-name": "Raggruppa 277",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3281",
    "data-name": "Tracciato 3281",
    d: "M144.466,12.9A243.006,243.006,0,0,0,241.5,7.746c82.04-21.327,149.532,6.31,166.494,23.7,19.69,20.206,22.94,46.794,13.826,71.092s-29.625,46.486-54.2,65.784c-19.219,15.079-41.672,28.924-68.548,36.787-26.257,7.682-55.029,9.2-83.146,10.237-36.163,1.334-72.946,2.01-107.388-4.178-28.085-5.039-56.938-17.5-59.386-37.16-2.08-16.76,15.913-33.256,13.407-49.975C59.039,100.621,18.782,89.021,5.478,67.589-10.044,42.6,9.653,15.061,36.592,9.16,64.674,3.008,109.187,7.45,144.466,12.9",
    transform: "translate(0 0)",
    fill: "#3e3c8d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_712",
    "data-name": "Raggruppa 712",
    transform: "translate(31.134 193.961)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_348",
    "data-name": "Rettangolo 348",
    width: 31.46,
    height: 30.229,
    transform: "translate(87.392 147.024)",
    fill: "#cba791"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_349",
    "data-name": "Rettangolo 349",
    width: 31.46,
    height: 30.229,
    transform: "translate(196.885 144.211)",
    fill: "#cba791"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_709",
    "data-name": "Raggruppa 709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_708",
    "data-name": "Raggruppa 708",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3824",
    "data-name": "Tracciato 3824",
    d: "M62.879,37.076c-3.734,3.416-1.966,15.17-.659,24.781,1.437,10.577,5.749,23.2,15.949,28.339,6.906,3.482,14.131,1.454,15.554,1.055,16.861-4.729,21.1-26.844,21.617-29.789a40.9,40.9,0,0,0-2.635-22.937c-1.489-3.8-3.422-8.744-6.854-9.227-4.174-.586-5.437,6.131-12.128,10.018-10.712,6.222-24.711-7.847-30.844-2.241",
    transform: "translate(64.584 31.167)",
    fill: "#cba791"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3825",
    "data-name": "Tracciato 3825",
    d: "M39.638,112.4c.64,3.773,3.172,6.743,5.689,9.014,6.166,5.57,16.874,9.621,23.837,5.749,1.966-1.094,3.071-2.507,3.69-2.108,1.826,1.173-.615,19.771-.615,19.771s7.583.888,27.243,1.055c19.765.167,42.857.087,56.592-3.515l2.46-19.949c2.548-1.483,4.421,1.394,9.755.791,2.67-.3,4.041-1.233,11.335-5.536,9.475-5.59,9.053-5.136,9.491-5.536,9.022-8.244,1.536-30.532-2.108-41.388-2.48-7.383-5.295-15.509-12.391-23.99a57.385,57.385,0,0,0-6.955-7.172,28.439,28.439,0,0,0-15.437-6.519l-20.713-2.259c-2.676,3.684,4.659,6.885,4.878,14.763.171,6.183-8.851,28.17-9.753,29.923-3.581,6.947-9.119,15.761-19.773,15.29C99.784,90.472,98.3,81.569,95.79,79.45,87.5,72.437,86.036,59.15,85.245,55.2c-1.987-9.933,2.013-21.246-1.318-23.726-3.174-2.365-7.732-.219-12.391,2.108A56.383,56.383,0,0,0,50.973,51.241c-3.1,4.479-10.14,14.644-9.753,27.68Z",
    transform: "translate(42.218 32.424)",
    fill: "#e3d400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3826",
    "data-name": "Tracciato 3826",
    d: "M55.715,87.347a43.036,43.036,0,0,0,2.011-10.272C57.879,73.55,57.373,70,58,66.558c2.063,3.114,2.121,7.164,1.371,10.712a34.78,34.78,0,0,1-3.461,10.156.1.1,0,0,1-.19-.078",
    transform: "translate(59.335 70.89)",
    fill: "#9c8f08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3827",
    "data-name": "Tracciato 3827",
    d: "M99.362,92.275c-3.647-10.5-4.869-24.68,1.731-33.743-.892,4.946-2.47,11.814-2.972,16.75A51.769,51.769,0,0,0,99.56,92.214c.035.118-.159.186-.2.062",
    transform: "translate(102.655 62.342)",
    fill: "#9c8f08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3828",
    "data-name": "Tracciato 3828",
    d: "M65.574,43.672C70.72,52.5,84.709,55.24,91.745,47.389A19.91,19.91,0,0,0,95.892,38a16.211,16.211,0,0,1-2.86,10.4c-6.887,9.493-24,6.257-27.457-4.733",
    transform: "translate(69.842 40.476)",
    fill: "#8a6757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3829",
    "data-name": "Tracciato 3829",
    d: "M61.723,32.726c3.1,10.959,12.481,24.492,24.254,26.538C73.376,60.3,61.752,44.388,61.723,32.726",
    transform: "translate(65.74 34.856)",
    fill: "#8a6757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3830",
    "data-name": "Tracciato 3830",
    d: "M93.8,31.407c2.042,11.234-6.819,28.785-19.544,28.523C85.85,57.148,92.671,42.389,93.8,31.407",
    transform: "translate(79.092 33.451)",
    fill: "#8a6757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3831",
    "data-name": "Tracciato 3831",
    d: "M113.238,45.332c-.095,5.239-1.873,10.292-3.275,15.3-3.366,9.848-5.914,21.014-14.945,27.455-4.463,2.963-11.139,4.558-15.876,1.384-3.511-2.439-4.372-6.676-7-9.437-5.068-4.518-7.725-11.18-9.093-17.576C62.012,57.28,61,52.043,61.39,46.782c.2-3.926.969-7.773.927-11.686a4.759,4.759,0,0,0-1.189-3.56c1.09.807,1.349,2.272,1.5,3.54.285,3.909-.262,7.847-.229,11.74.254,9.931,2.5,21.018,8.421,29.078,1.64,2.011,4.085,3.763,5.084,6.088,1.828,3.271,3.787,6.538,7.575,7.091A15.855,15.855,0,0,0,93.971,86.53c8.487-5.974,11.451-16.9,15.048-26.216,1.7-4.892,3.68-9.8,4.219-14.982",
    transform: "translate(65.107 33.587)",
    fill: "#9c8f08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3832",
    "data-name": "Tracciato 3832",
    d: "M60.238,29.124c-1.908,8.6-.5,15.453,1.231,23.9,1.667,8.128,2.9,14.154,7.381,20.564,2.48,3.55,10.148,14.522,19.86,13.884,9.413-.615,18.77-12.006,20.74-22.144.611-3.149,1.458-11.059,3.69-11.249.739-.062,1.21.758,1.933.527,1.2-.382,1.84-2.17,2.462-5.888a50.354,50.354,0,0,0,1.053-9.051c.07-2.858-.609-6.154-1.757-6.325-.983-.149-1.423,2.131-4.041,3.339-.448.207-2.437,1.123-3.339.351-.865-.741-.13-2.524.7-6.678,0,0,.562-2.8.88-5.45.925-7.725-8.376-12.587-11.073-14.235C97.87,9.4,84.506,1.6,72.717,8.209c-8.954,5.022-11.189,15.1-12.479,20.915",
    transform: "translate(63.184 5.945)",
    fill: "#cba791"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3833",
    "data-name": "Tracciato 3833",
    d: "M60.875,47.019c-2.759-.7-2.433-12.229-2.813-15.114-.878-6.693,2.013-12.382,2.988-14.588a30,30,0,0,1,6.327-8.962C77.6-1.3,98.464-3.557,110.086,6.773c4.485,3.986,6.656,7.12,7.909,10.369,2.509,6.507,2.284,18.629-1.055,25.308-.83,1.66-1.33,3.635-3.339,2.813-2.152-.882-3.922-2.643-4.219-4.394-.89-5.243,3.193-7.75,2.462-12.126-.048-.287-3.564-7.911-8.481-9.534a14.436,14.436,0,0,0-6.678-.351c-.752,2.445-1.46,4.217-2.241,4.789-3.465,2.538-8.746,1.194-11.775-.351-3.409-1.741-5.468-7.823-7.909-7.909C72.3,15.3,68.188,20.07,67.2,22.413a72.069,72.069,0,0,0-3.868,14.061c-.551,4.81.44,11.282-2.46,10.544",
    transform: "translate(61.667 0.001)",
    fill: "#361300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3834",
    "data-name": "Tracciato 3834",
    d: "M75.6,24.576c-.345,4.256-2.1,8.116-.081,12.161-4.043-2.7-2.4-8.911.081-12.161",
    transform: "translate(77.827 26.176)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3835",
    "data-name": "Tracciato 3835",
    d: "M69.032,32.177c.584,1.024,1.609,3.087,2.9,2.672a7.915,7.915,0,0,1,2.581-.481,22.327,22.327,0,0,1,4.979.65c1.163.25,2.046-3.085,1.014-3.81a2.01,2.01,0,0,0-1.121-.217c2.175-1.08,2.974,2.02,2.3,3.6-.229.989-1.363,2.187-2.459,1.867-2.34-.355-4.725-.931-6.99-.446-2.336.314-2.968-2.166-3.2-3.837",
    transform: "translate(73.525 32.77)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3836",
    "data-name": "Tracciato 3836",
    d: "M77.9,28.879c-4.225-3.663-9.5-7.486-15.224-4.812,4.444-5.811,13.508-1.049,15.224,4.812",
    transform: "translate(66.761 22.821)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3837",
    "data-name": "Tracciato 3837",
    d: "M74.9,26.8c.9-4.919,7.767-9.031,11.732-4.878C81.551,21.049,78.627,23.8,74.9,26.8",
    transform: "translate(79.779 21.533)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3838",
    "data-name": "Tracciato 3838",
    d: "M74.037,26.422c.025-1.724-5.987-4-9.623-2.241-1.07.518-1.169,1.016-1.185,1.119-.2,1.251,2.42,3.06,4.944,3.362,2.687.322,5.848-1,5.865-2.241",
    transform: "translate(67.333 25.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3839",
    "data-name": "Tracciato 3839",
    d: "M85.935,25.458c-.264-1.7-6.571-2.945-9.861-.605-.971.69-.985,1.2-.983,1.3.014,1.266,2.9,2.612,5.433,2.49,2.705-.132,5.6-1.96,5.411-3.188",
    transform: "translate(79.978 25.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3840",
    "data-name": "Tracciato 3840",
    d: "M67.682,25.494A1.384,1.384,0,1,1,66.3,24.11a1.384,1.384,0,0,1,1.384,1.384",
    transform: "translate(69.14 25.679)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3841",
    "data-name": "Tracciato 3841",
    d: "M79.539,25.557a1.384,1.384,0,1,1-1.384-1.384,1.384,1.384,0,0,1,1.384,1.384",
    transform: "translate(81.769 25.746)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3842",
    "data-name": "Tracciato 3842",
    d: "M73.892,25.736c-.078.287-3.5-.025-10.327-.661-.593-.056-.39-.357-.287-.491.308-.4,2.028-1.268,5.049-1.049,2.934.215,5.718,1.652,5.565,2.2",
    transform: "translate(67.269 25.03)",
    fill: "#8a6758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3843",
    "data-name": "Tracciato 3843",
    d: "M86.2,25.206c-.027.339-3.6.533-10.732.909-.62.033-.467-.343-.386-.512.24-.506,1.842-1.762,4.987-2,3.054-.229,6.183.956,6.131,1.6",
    transform: "translate(79.888 25.109)",
    fill: "#8a6758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3844",
    "data-name": "Tracciato 3844",
    d: "M68.818,38.338c-.52.892,1.536,3.428,3.955,4.549a8.2,8.2,0,0,0,6.524,0,9.172,9.172,0,0,0,3.3-2.571c.469-.522,1.951-2.175,1.582-2.7-.384-.547-2.346.727-4.942,1.318-5.681,1.295-9.747-1.737-10.414-.595",
    transform: "translate(73.21 39.921)",
    fill: "#8a6758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3845",
    "data-name": "Tracciato 3845",
    d: "M68.628,38.489c.229-.884,2.245-1.086,3.23-1.185,2.331-.235,2.823.407,6,.593a20.389,20.389,0,0,0,4.944-.264c1.64-.308,2.484-1,2.7-.725.32.4-1,2.377-2.767,3.69a10.97,10.97,0,0,1-11.007.923c-1.371-.675-3.347-2.067-3.1-3.032",
    transform: "translate(73.072 39.243)",
    fill: "#8a6758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3846",
    "data-name": "Tracciato 3846",
    d: "M63.631,25.853c-.938-1.836-2.916-4.518-4.14-4.132-1.553.487-1.6,5.813-.192,10.028.768,2.3,2.668,6.363,4.074,6.1,1.7-.32,2.821-6.978.258-11.992",
    transform: "translate(62.075 23.094)",
    fill: "#cba791"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "M",
    transform: "translate(135.598 141.379) rotate(-14.214)",
    fill: "#003d8c",
    fontSize: 10,
    fontFamily: "HGSSoeiKakupoptai"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("text", {
    id: "I",
    transform: "translate(144.351 139.294) rotate(-8.706)",
    fill: "#003d8c",
    fontSize: 11,
    fontFamily: "HGSSoeiKakupoptai"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    id: "M-2",
    "data-name": "M",
    transform: "translate(147.434 138.637) rotate(-2.191)",
    fill: "#003d8c",
    fontSize: 10,
    fontFamily: "HGSSoeiKakupoptai"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("text", {
    id: "M-3",
    "data-name": "M",
    transform: "translate(156.402 138.236) rotate(9.99)",
    fill: "#003d8c",
    fontSize: 10,
    fontFamily: "HGSSoeiKakupoptai"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("text", {
    id: "O",
    transform: "translate(165.229 139.845) rotate(23.957)",
    fill: "#003d8c",
    fontSize: 11,
    fontFamily: "HGSSoeiKakupoptai"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_711",
    "data-name": "Raggruppa 711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_710",
    "data-name": "Raggruppa 710",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3847",
    "data-name": "Tracciato 3847",
    d: "M15.588,73.354V99.474H9.634L6.1,87.6V99.474H.422V73.354H6.1L9.909,85.115V73.354Z",
    transform: "translate(0.449 78.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3848",
    "data-name": "Tracciato 3848",
    d: "M15.588,73.354V99.474H9.634L6.1,87.6V99.474H.422V73.354H6.1L9.909,85.115V73.354Z",
    transform: "translate(0.449 78.129)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3849",
    "data-name": "Tracciato 3849",
    d: "M24.93,88.932q0,3.937-.186,5.574a6.237,6.237,0,0,1-3.8,5.076,9.623,9.623,0,0,1-3.872.725,9.851,9.851,0,0,1-3.767-.686,6.279,6.279,0,0,1-3.9-5.041,55.632,55.632,0,0,1-.192-5.648V84.463q0-3.934.186-5.574a6.241,6.241,0,0,1,3.8-5.074,9.623,9.623,0,0,1,3.872-.727,9.861,9.861,0,0,1,3.769.686,6.281,6.281,0,0,1,3.895,5.043,54.792,54.792,0,0,1,.194,5.646ZM18.138,80.35a8.1,8.1,0,0,0-.2-2.331.8.8,0,0,0-.83-.508.927.927,0,0,0-.816.411,5.85,5.85,0,0,0-.281,2.429v12.2a11.86,11.86,0,0,0,.186,2.809.808.808,0,0,0,.863.531.833.833,0,0,0,.886-.611,12.853,12.853,0,0,0,.194-2.922Z",
    transform: "translate(9.817 77.846)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3850",
    "data-name": "Tracciato 3850",
    d: "M24.93,88.932q0,3.937-.186,5.574a6.237,6.237,0,0,1-3.8,5.076,9.623,9.623,0,0,1-3.872.725,9.851,9.851,0,0,1-3.767-.686,6.279,6.279,0,0,1-3.9-5.041,55.632,55.632,0,0,1-.192-5.648V84.463q0-3.934.186-5.574a6.241,6.241,0,0,1,3.8-5.074,9.623,9.623,0,0,1,3.872-.727,9.861,9.861,0,0,1,3.769.686,6.281,6.281,0,0,1,3.895,5.043,54.792,54.792,0,0,1,.194,5.646ZM18.138,80.35a8.1,8.1,0,0,0-.2-2.331.8.8,0,0,0-.83-.508.927.927,0,0,0-.816.411,5.85,5.85,0,0,0-.281,2.429v12.2a11.86,11.86,0,0,0,.186,2.809.808.808,0,0,0,.863.531.833.833,0,0,0,.886-.611,12.853,12.853,0,0,0,.194-2.922Z",
    transform: "translate(9.817 77.846)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3851",
    "data-name": "Tracciato 3851",
    d: "M33.442,73.354V99.474H27.488L23.955,87.6V99.474H18.276V73.354h5.679l3.808,11.761V73.354Z",
    transform: "translate(19.466 78.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3852",
    "data-name": "Tracciato 3852",
    d: "M33.442,73.354V99.474H27.488L23.955,87.6V99.474H18.276V73.354h5.679l3.808,11.761V73.354Z",
    transform: "translate(19.466 78.129)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3853",
    "data-name": "Tracciato 3853",
    d: "M42.33,73.354V99.474H36.376L32.843,87.6V99.474H27.164V73.354h5.679l3.808,11.761V73.354Z",
    transform: "translate(28.932 78.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3854",
    "data-name": "Tracciato 3854",
    d: "M42.33,73.354V99.474H36.376L32.843,87.6V99.474H27.164V73.354h5.679l3.808,11.761V73.354Z",
    transform: "translate(28.932 78.129)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3855",
    "data-name": "Tracciato 3855",
    d: "M48.588,73.354l3.884,26.121H45.531l-.366-4.7H42.735l-.407,4.7H35.307L38.77,73.354Zm-3.6,16.8q-.517-4.439-1.035-10.97-1.038,7.5-1.305,10.97Z",
    transform: "translate(37.605 78.128)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3856",
    "data-name": "Tracciato 3856",
    d: "M48.588,73.354l3.884,26.121H45.531l-.366-4.7H42.735l-.407,4.7H35.307L38.77,73.354Zm-3.6,16.8q-.517-4.439-1.035-10.97-1.038,7.5-1.305,10.97Z",
    transform: "translate(37.605 78.128)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3857",
    "data-name": "Tracciato 3857",
    d: "M48.8,83.526v2.34a8.8,8.8,0,0,1-.436,3.017,4.449,4.449,0,0,1-1.508,2,5.881,5.881,0,0,1-2.429,1.1V90.109a2,2,0,0,0,1.1-1.468h-1.1V83.526Z",
    transform: "translate(47.316 88.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3858",
    "data-name": "Tracciato 3858",
    d: "M48.8,83.526v2.34a8.8,8.8,0,0,1-.436,3.017,4.449,4.449,0,0,1-1.508,2,5.881,5.881,0,0,1-2.429,1.1V90.109a2,2,0,0,0,1.1-1.468h-1.1V83.526Z",
    transform: "translate(47.316 88.962)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3859",
    "data-name": "Tracciato 3859",
    d: "M71.712,73.355V99.474H65.775L65.767,81.84,63.4,99.474H59.194L56.7,82.245l-.006,17.229H50.756V73.355h8.787q.39,2.357.807,5.553l.964,6.643,1.561-12.2Z",
    transform: "translate(54.059 78.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3860",
    "data-name": "Tracciato 3860",
    d: "M71.712,73.355V99.474H65.775L65.767,81.84,63.4,99.474H59.194L56.7,82.245l-.006,17.229H50.756V73.355h8.787q.39,2.357.807,5.553l.964,6.643,1.561-12.2Z",
    transform: "translate(54.059 78.129)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3861",
    "data-name": "Tracciato 3861",
    d: "M66.445,73.355v2.34a8.814,8.814,0,0,1-.436,3.009,4.384,4.384,0,0,1-1.508,2,6.086,6.086,0,0,1-2.429,1.1V79.922a1.949,1.949,0,0,0,1.1-1.452h-1.1V73.355Z",
    transform: "translate(66.113 78.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3862",
    "data-name": "Tracciato 3862",
    d: "M66.445,73.355v2.34a8.814,8.814,0,0,1-.436,3.009,4.384,4.384,0,0,1-1.508,2,6.086,6.086,0,0,1-2.429,1.1V79.922a1.949,1.949,0,0,0,1.1-1.452h-1.1V73.355Z",
    transform: "translate(66.113 78.129)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3863",
    "data-name": "Tracciato 3863",
    d: "M80.977,73.354V99.474H74.185V88.5H72.153v10.97H65.361V73.354h6.792v9.34h2.032v-9.34Z",
    transform: "translate(69.615 78.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3864",
    "data-name": "Tracciato 3864",
    d: "M80.977,73.354V99.474H74.185V88.5H72.153v10.97H65.361V73.354h6.792v9.34h2.032v-9.34Z",
    transform: "translate(69.615 78.129)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3865",
    "data-name": "Tracciato 3865",
    d: "M87,73.354l3.884,26.121H83.945l-.366-4.7H81.151l-.409,4.7H73.721l3.463-26.121Zm-3.6,16.8q-.514-4.439-1.035-10.97-1.038,7.5-1.3,10.97Z",
    transform: "translate(78.519 78.128)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3866",
    "data-name": "Tracciato 3866",
    d: "M87,73.354l3.884,26.121H83.945l-.366-4.7H81.151l-.409,4.7H73.721l3.463-26.121Zm-3.6,16.8q-.514-4.439-1.035-10.97-1.038,7.5-1.3,10.97Z",
    transform: "translate(78.519 78.128)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3867",
    "data-name": "Tracciato 3867",
    d: "M97.981,73.354V99.474H92.028L88.494,87.6V99.474H82.815V73.354h5.679L92.3,85.115V73.354Z",
    transform: "translate(88.205 78.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3868",
    "data-name": "Tracciato 3868",
    d: "M97.981,73.354V99.474H92.028L88.494,87.6V99.474H82.815V73.354h5.679L92.3,85.115V73.354Z",
    transform: "translate(88.205 78.129)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3869",
    "data-name": "Tracciato 3869",
    d: "M106.87,73.354V99.474h-5.954L97.383,87.6V99.474H91.7V73.354h5.679l3.808,11.761V73.354Z",
    transform: "translate(97.672 78.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3870",
    "data-name": "Tracciato 3870",
    d: "M106.87,73.354V99.474h-5.954L97.383,87.6V99.474H91.7V73.354h5.679l3.808,11.761V73.354Z",
    transform: "translate(97.672 78.129)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3871",
    "data-name": "Tracciato 3871",
    d: "M116.211,88.932q0,3.937-.186,5.574a6.237,6.237,0,0,1-3.8,5.076,9.609,9.609,0,0,1-3.872.725,9.858,9.858,0,0,1-3.767-.686,6.279,6.279,0,0,1-3.9-5.041,55.628,55.628,0,0,1-.192-5.648V84.463q0-3.934.186-5.574a6.241,6.241,0,0,1,3.8-5.074,9.623,9.623,0,0,1,3.872-.727,9.861,9.861,0,0,1,3.769.686,6.281,6.281,0,0,1,3.895,5.043,54.8,54.8,0,0,1,.194,5.646Zm-6.792-8.582a8.021,8.021,0,0,0-.2-2.331.8.8,0,0,0-.83-.508.927.927,0,0,0-.816.411,5.888,5.888,0,0,0-.281,2.429v12.2a11.982,11.982,0,0,0,.186,2.809.808.808,0,0,0,.863.531.833.833,0,0,0,.886-.611,12.853,12.853,0,0,0,.194-2.922Z",
    transform: "translate(107.039 77.846)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3872",
    "data-name": "Tracciato 3872",
    d: "M116.211,88.932q0,3.937-.186,5.574a6.237,6.237,0,0,1-3.8,5.076,9.609,9.609,0,0,1-3.872.725,9.858,9.858,0,0,1-3.767-.686,6.279,6.279,0,0,1-3.9-5.041,55.628,55.628,0,0,1-.192-5.648V84.463q0-3.934.186-5.574a6.241,6.241,0,0,1,3.8-5.074,9.623,9.623,0,0,1,3.872-.727,9.861,9.861,0,0,1,3.769.686,6.281,6.281,0,0,1,3.895,5.043,54.8,54.8,0,0,1,.194,5.646Zm-6.792-8.582a8.021,8.021,0,0,0-.2-2.331.8.8,0,0,0-.83-.508.927.927,0,0,0-.816.411,5.888,5.888,0,0,0-.281,2.429v12.2a11.982,11.982,0,0,0,.186,2.809.808.808,0,0,0,.863.531.833.833,0,0,0,.886-.611,12.853,12.853,0,0,0,.194-2.922Z",
    transform: "translate(107.039 77.846)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3873",
    "data-name": "Tracciato 3873",
    d: "M112.6,73.354h11.5v5.227h-4.71v4.954h4.194V88.5h-4.194v10.97H112.6Z",
    transform: "translate(119.931 78.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3874",
    "data-name": "Tracciato 3874",
    d: "M112.6,73.354h11.5v5.227h-4.71v4.954h4.194V88.5h-4.194v10.97H112.6Z",
    transform: "translate(119.931 78.129)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3875",
    "data-name": "Tracciato 3875",
    d: "M131.408,73.354l3.884,26.121h-6.941l-.366-4.7h-2.429l-.409,4.7h-7.021l3.463-26.121Zm-3.6,16.8q-.514-4.439-1.035-10.97-1.038,7.5-1.3,10.97Z",
    transform: "translate(125.815 78.128)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3876",
    "data-name": "Tracciato 3876",
    d: "M131.408,73.354l3.884,26.121h-6.941l-.366-4.7h-2.429l-.409,4.7h-7.021l3.463-26.121Zm-3.6,16.8q-.514-4.439-1.035-10.97-1.038,7.5-1.3,10.97Z",
    transform: "translate(125.815 78.128)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3877",
    "data-name": "Tracciato 3877",
    d: "M140.62,73.354v5.227h-4.033V99.474h-6.792V78.581h-4.017V73.354Z",
    transform: "translate(133.964 78.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3878",
    "data-name": "Tracciato 3878",
    d: "M140.62,73.354v5.227h-4.033V99.474h-6.792V78.581h-4.017V73.354Z",
    transform: "translate(133.964 78.129)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3879",
    "data-name": "Tracciato 3879",
    d: "M148.218,73.354v5.227h-4.033V99.474h-6.792V78.581h-4.017V73.354Z",
    transform: "translate(142.057 78.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3880",
    "data-name": "Tracciato 3880",
    d: "M148.218,73.354v5.227h-4.033V99.474h-6.792V78.581h-4.017V73.354Z",
    transform: "translate(142.057 78.129)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3881",
    "data-name": "Tracciato 3881",
    d: "M157.157,88.932q0,3.937-.186,5.574a6.237,6.237,0,0,1-3.8,5.076,9.609,9.609,0,0,1-3.872.725,9.858,9.858,0,0,1-3.767-.686,6.279,6.279,0,0,1-3.9-5.041,55.64,55.64,0,0,1-.192-5.648V84.463q0-3.934.186-5.574a6.241,6.241,0,0,1,3.8-5.074,9.623,9.623,0,0,1,3.872-.727,9.861,9.861,0,0,1,3.769.686,6.281,6.281,0,0,1,3.895,5.043,54.8,54.8,0,0,1,.194,5.646Zm-6.792-8.582a8.022,8.022,0,0,0-.2-2.331.8.8,0,0,0-.83-.508.927.927,0,0,0-.816.411,5.888,5.888,0,0,0-.281,2.429v12.2a11.981,11.981,0,0,0,.186,2.809.808.808,0,0,0,.863.531.833.833,0,0,0,.886-.611,12.85,12.85,0,0,0,.194-2.922Z",
    transform: "translate(150.65 77.846)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3882",
    "data-name": "Tracciato 3882",
    d: "M157.157,88.932q0,3.937-.186,5.574a6.237,6.237,0,0,1-3.8,5.076,9.609,9.609,0,0,1-3.872.725,9.858,9.858,0,0,1-3.767-.686,6.279,6.279,0,0,1-3.9-5.041,55.64,55.64,0,0,1-.192-5.648V84.463q0-3.934.186-5.574a6.241,6.241,0,0,1,3.8-5.074,9.623,9.623,0,0,1,3.872-.727,9.861,9.861,0,0,1,3.769.686,6.281,6.281,0,0,1,3.895,5.043,54.8,54.8,0,0,1,.194,5.646Zm-6.792-8.582a8.022,8.022,0,0,0-.2-2.331.8.8,0,0,0-.83-.508.927.927,0,0,0-.816.411,5.888,5.888,0,0,0-.281,2.429v12.2a11.981,11.981,0,0,0,.186,2.809.808.808,0,0,0,.863.531.833.833,0,0,0,.886-.611,12.85,12.85,0,0,0,.194-2.922Z",
    transform: "translate(150.65 77.846)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3883",
    "data-name": "Tracciato 3883",
    d: "M15.911,90.631v17.458a30.089,30.089,0,0,1-.194,4.169,5.652,5.652,0,0,1-1.144,2.468,5.933,5.933,0,0,1-2.509,1.921,9.443,9.443,0,0,1-3.672.655,10.333,10.333,0,0,1-4.13-.774,6.208,6.208,0,0,1-2.676-2.018,5.549,5.549,0,0,1-1.049-2.623q-.161-1.378-.161-5.8V90.631H7.167v19.587a7.807,7.807,0,0,0,.184,2.185.728.728,0,0,0,.752.477.784.784,0,0,0,.83-.525,9.741,9.741,0,0,0,.186-2.476V90.631Z",
    transform: "translate(0.399 96.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3884",
    "data-name": "Tracciato 3884",
    d: "M15.911,90.631v17.458a30.089,30.089,0,0,1-.194,4.169,5.652,5.652,0,0,1-1.144,2.468,5.933,5.933,0,0,1-2.509,1.921,9.443,9.443,0,0,1-3.672.655,10.333,10.333,0,0,1-4.13-.774,6.208,6.208,0,0,1-2.676-2.018,5.549,5.549,0,0,1-1.049-2.623q-.161-1.378-.161-5.8V90.631H7.167v19.587a7.807,7.807,0,0,0,.184,2.185.728.728,0,0,0,.752.477.784.784,0,0,0,.83-.525,9.741,9.741,0,0,0,.186-2.476V90.631Z",
    transform: "translate(0.399 96.53)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3885",
    "data-name": "Tracciato 3885",
    d: "M24.562,90.631v26.121H18.609l-3.533-11.874v11.874H9.4V90.631h5.679l3.808,11.763V90.631Z",
    transform: "translate(10.008 96.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3886",
    "data-name": "Tracciato 3886",
    d: "M24.562,90.631v26.121H18.609l-3.533-11.874v11.874H9.4V90.631h5.679l3.808,11.763V90.631Z",
    transform: "translate(10.008 96.53)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3887",
    "data-name": "Tracciato 3887",
    d: "M21.328,90.631H28.1a17.929,17.929,0,0,1,4.865.5,4.826,4.826,0,0,1,2.67,2.024,9.1,9.1,0,0,1,1.016,4.909,5.276,5.276,0,0,1-.719,3.193,4.985,4.985,0,0,1-2.831,1.388,5.022,5.022,0,0,1,3.195,1.768,6.829,6.829,0,0,1,.838,3.785v2.42a9.592,9.592,0,0,1-.605,3.924,3.271,3.271,0,0,1-1.927,1.745,19.889,19.889,0,0,1-5.421.467H21.328ZM28.12,95.1v5.809c.291-.01.516-.017.677-.017.667,0,1.09-.163,1.274-.491a8.037,8.037,0,0,0,.275-2.817,4.565,4.565,0,0,0-.225-1.718,1.088,1.088,0,0,0-.589-.62A5.27,5.27,0,0,0,28.12,95.1m0,9.875v7.308a2.907,2.907,0,0,0,1.832-.452,3.161,3.161,0,0,0,.394-1.985v-2.435a3.439,3.439,0,0,0-.355-2.034,3.2,3.2,0,0,0-1.871-.4",
    transform: "translate(22.716 96.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3888",
    "data-name": "Tracciato 3888",
    d: "M21.328,90.631H28.1a17.929,17.929,0,0,1,4.865.5,4.826,4.826,0,0,1,2.67,2.024,9.1,9.1,0,0,1,1.016,4.909,5.276,5.276,0,0,1-.719,3.193,4.985,4.985,0,0,1-2.831,1.388,5.022,5.022,0,0,1,3.195,1.768,6.829,6.829,0,0,1,.838,3.785v2.42a9.592,9.592,0,0,1-.605,3.924,3.271,3.271,0,0,1-1.927,1.745,19.889,19.889,0,0,1-5.421.467H21.328ZM28.12,95.1v5.809c.291-.01.516-.017.677-.017.667,0,1.09-.163,1.274-.491a8.037,8.037,0,0,0,.275-2.817,4.565,4.565,0,0,0-.225-1.718,1.088,1.088,0,0,0-.589-.62A5.27,5.27,0,0,0,28.12,95.1Zm0,9.875v7.308a2.907,2.907,0,0,0,1.832-.452,3.161,3.161,0,0,0,.394-1.985v-2.435a3.439,3.439,0,0,0-.355-2.034A3.2,3.2,0,0,0,28.12,104.975Z",
    transform: "translate(22.716 96.53)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3889",
    "data-name": "Tracciato 3889",
    d: "M45.878,90.631v17.458a30.089,30.089,0,0,1-.194,4.169,5.675,5.675,0,0,1-1.144,2.468,5.946,5.946,0,0,1-2.509,1.921,9.451,9.451,0,0,1-3.672.655,10.333,10.333,0,0,1-4.13-.774,6.208,6.208,0,0,1-2.676-2.018,5.528,5.528,0,0,1-1.049-2.623q-.164-1.378-.161-5.8V90.631h6.792v19.587a7.725,7.725,0,0,0,.184,2.185.728.728,0,0,0,.752.477.786.786,0,0,0,.83-.525,9.741,9.741,0,0,0,.186-2.476V90.631Z",
    transform: "translate(32.317 96.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3890",
    "data-name": "Tracciato 3890",
    d: "M45.878,90.631v17.458a30.089,30.089,0,0,1-.194,4.169,5.675,5.675,0,0,1-1.144,2.468,5.946,5.946,0,0,1-2.509,1.921,9.451,9.451,0,0,1-3.672.655,10.333,10.333,0,0,1-4.13-.774,6.208,6.208,0,0,1-2.676-2.018,5.528,5.528,0,0,1-1.049-2.623q-.164-1.378-.161-5.8V90.631h6.792v19.587a7.725,7.725,0,0,0,.184,2.185.728.728,0,0,0,.752.477.786.786,0,0,0,.83-.525,9.741,9.741,0,0,0,.186-2.476V90.631Z",
    transform: "translate(32.317 96.53)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3891",
    "data-name": "Tracciato 3891",
    d: "M54.982,106.21q0,3.934-.186,5.574a6.238,6.238,0,0,1-3.8,5.074,9.609,9.609,0,0,1-3.872.727,9.9,9.9,0,0,1-3.767-.686,6.286,6.286,0,0,1-3.9-5.043,55.583,55.583,0,0,1-.192-5.646v-4.471q0-3.934.186-5.574a6.241,6.241,0,0,1,3.8-5.074,9.623,9.623,0,0,1,3.872-.727,9.861,9.861,0,0,1,3.769.686,6.281,6.281,0,0,1,3.895,5.043,54.792,54.792,0,0,1,.194,5.646ZM48.19,97.626a8.021,8.021,0,0,0-.2-2.331.8.8,0,0,0-.83-.508.927.927,0,0,0-.816.411,5.888,5.888,0,0,0-.281,2.429v12.2a11.971,11.971,0,0,0,.186,2.806.807.807,0,0,0,.863.533A.835.835,0,0,0,48,112.55a12.843,12.843,0,0,0,.194-2.92Z",
    transform: "translate(41.825 96.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3892",
    "data-name": "Tracciato 3892",
    d: "M54.982,106.21q0,3.934-.186,5.574a6.238,6.238,0,0,1-3.8,5.074,9.609,9.609,0,0,1-3.872.727,9.9,9.9,0,0,1-3.767-.686,6.286,6.286,0,0,1-3.9-5.043,55.583,55.583,0,0,1-.192-5.646v-4.471q0-3.934.186-5.574a6.241,6.241,0,0,1,3.8-5.074,9.623,9.623,0,0,1,3.872-.727,9.861,9.861,0,0,1,3.769.686,6.281,6.281,0,0,1,3.895,5.043,54.792,54.792,0,0,1,.194,5.646ZM48.19,97.626a8.021,8.021,0,0,0-.2-2.331.8.8,0,0,0-.83-.508.927.927,0,0,0-.816.411,5.888,5.888,0,0,0-.281,2.429v12.2a11.971,11.971,0,0,0,.186,2.806.807.807,0,0,0,.863.533A.835.835,0,0,0,48,112.55a12.843,12.843,0,0,0,.194-2.92Z",
    transform: "translate(41.825 96.246)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3893",
    "data-name": "Tracciato 3893",
    d: "M63.495,90.631v26.121H57.541l-3.533-11.874v11.874H48.329V90.631h5.679l3.808,11.763V90.631Z",
    transform: "translate(51.474 96.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3894",
    "data-name": "Tracciato 3894",
    d: "M63.495,90.631v26.121H57.541l-3.533-11.874v11.874H48.329V90.631h5.679l3.808,11.763V90.631Z",
    transform: "translate(51.474 96.53)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3895",
    "data-name": "Tracciato 3895",
    d: "M72.836,106.21q0,3.934-.186,5.574a6.238,6.238,0,0,1-3.8,5.074,9.623,9.623,0,0,1-3.872.727,9.89,9.89,0,0,1-3.767-.686,6.286,6.286,0,0,1-3.9-5.043,55.585,55.585,0,0,1-.192-5.646v-4.471q0-3.934.186-5.574a6.241,6.241,0,0,1,3.8-5.074,9.623,9.623,0,0,1,3.872-.727,9.861,9.861,0,0,1,3.769.686,6.281,6.281,0,0,1,3.895,5.043,54.8,54.8,0,0,1,.194,5.646Zm-6.792-8.585a8.1,8.1,0,0,0-.2-2.331.8.8,0,0,0-.83-.508.927.927,0,0,0-.816.411,5.85,5.85,0,0,0-.281,2.429v12.2a11.851,11.851,0,0,0,.186,2.806.807.807,0,0,0,.863.533.835.835,0,0,0,.886-.613,12.842,12.842,0,0,0,.194-2.92Z",
    transform: "translate(60.841 96.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3896",
    "data-name": "Tracciato 3896",
    d: "M72.836,106.21q0,3.934-.186,5.574a6.238,6.238,0,0,1-3.8,5.074,9.623,9.623,0,0,1-3.872.727,9.89,9.89,0,0,1-3.767-.686,6.286,6.286,0,0,1-3.9-5.043,55.585,55.585,0,0,1-.192-5.646v-4.471q0-3.934.186-5.574a6.241,6.241,0,0,1,3.8-5.074,9.623,9.623,0,0,1,3.872-.727,9.861,9.861,0,0,1,3.769.686,6.281,6.281,0,0,1,3.895,5.043,54.8,54.8,0,0,1,.194,5.646Zm-6.792-8.585a8.1,8.1,0,0,0-.2-2.331.8.8,0,0,0-.83-.508.927.927,0,0,0-.816.411,5.85,5.85,0,0,0-.281,2.429v12.2a11.851,11.851,0,0,0,.186,2.806.807.807,0,0,0,.863.533.835.835,0,0,0,.886-.613,12.842,12.842,0,0,0,.194-2.92Z",
    transform: "translate(60.841 96.246)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3897",
    "data-name": "Tracciato 3897",
    d: "M70.18,100.8v2.34a8.8,8.8,0,0,1-.436,3.017,4.449,4.449,0,0,1-1.507,2,5.881,5.881,0,0,1-2.429,1.1v-1.871a2,2,0,0,0,1.1-1.468h-1.1V100.8Z",
    transform: "translate(70.091 107.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3898",
    "data-name": "Tracciato 3898",
    d: "M70.18,100.8v2.34a8.8,8.8,0,0,1-.436,3.017,4.449,4.449,0,0,1-1.507,2,5.881,5.881,0,0,1-2.429,1.1v-1.871a2,2,0,0,0,1.1-1.468h-1.1V100.8Z",
    transform: "translate(70.091 107.364)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3899",
    "data-name": "Tracciato 3899",
    d: "M88.1,102.289H81.3V97.748a8.08,8.08,0,0,0-.219-2.472.934.934,0,0,0-.958-.489,1,1,0,0,0-1.066.6,9.086,9.086,0,0,0-.225,2.581V110.1a8.459,8.459,0,0,0,.225,2.484.966.966,0,0,0,1.016.582.956.956,0,0,0,.993-.584,9.533,9.533,0,0,0,.233-2.732v-3.284H88.1v1.018a20.172,20.172,0,0,1-.572,5.753,5.881,5.881,0,0,1-2.534,2.972,8.675,8.675,0,0,1-4.832,1.276,10.031,10.031,0,0,1-4.921-1.08,5.255,5.255,0,0,1-2.565-2.992,19.677,19.677,0,0,1-.628-5.753v-7.63a34.227,34.227,0,0,1,.192-4.235,5.942,5.942,0,0,1,1.154-2.72,6.441,6.441,0,0,1,2.662-2.057,10.9,10.9,0,0,1,8.865.411,5.569,5.569,0,0,1,2.565,2.891,17.39,17.39,0,0,1,.613,5.39Z",
    transform: "translate(76.734 96.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3900",
    "data-name": "Tracciato 3900",
    d: "M88.1,102.289H81.3V97.748a8.08,8.08,0,0,0-.219-2.472.934.934,0,0,0-.958-.489,1,1,0,0,0-1.066.6,9.086,9.086,0,0,0-.225,2.581V110.1a8.459,8.459,0,0,0,.225,2.484.966.966,0,0,0,1.016.582.956.956,0,0,0,.993-.584,9.533,9.533,0,0,0,.233-2.732v-3.284H88.1v1.018a20.172,20.172,0,0,1-.572,5.753,5.881,5.881,0,0,1-2.534,2.972,8.675,8.675,0,0,1-4.832,1.276,10.031,10.031,0,0,1-4.921-1.08,5.255,5.255,0,0,1-2.565-2.992,19.677,19.677,0,0,1-.628-5.753v-7.63a34.227,34.227,0,0,1,.192-4.235,5.942,5.942,0,0,1,1.154-2.72,6.441,6.441,0,0,1,2.662-2.057,10.9,10.9,0,0,1,8.865.411,5.569,5.569,0,0,1,2.565,2.891,17.39,17.39,0,0,1,.613,5.39Z",
    transform: "translate(76.734 96.246)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3901",
    "data-name": "Tracciato 3901",
    d: "M96.838,90.631v26.121H90.046V105.781H88.014v10.972H81.222V90.631h6.792v9.34h2.032v-9.34Z",
    transform: "translate(86.509 96.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3902",
    "data-name": "Tracciato 3902",
    d: "M96.838,90.631v26.121H90.046V105.781H88.014v10.972H81.222V90.631h6.792v9.34h2.032v-9.34Z",
    transform: "translate(86.509 96.53)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3903",
    "data-name": "Tracciato 3903",
    d: "M90.329,90.631h11.325v5.227H97.121v4.954h4.244v4.969H97.121v5.745h4.985v5.227H90.329Z",
    transform: "translate(96.208 96.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3904",
    "data-name": "Tracciato 3904",
    d: "M90.329,90.631h11.325v5.227H97.121v4.954h4.244v4.969H97.121v5.745h4.985v5.227H90.329Z",
    transform: "translate(96.208 96.53)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3905",
    "data-name": "Tracciato 3905",
    d: "M117.194,90.631l-3.457,26.121H103.42L99.5,90.631h7.162q1.251,10.792,1.784,18.264.527-7.549,1.117-13.407l.471-4.857Z",
    transform: "translate(105.972 96.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3906",
    "data-name": "Tracciato 3906",
    d: "M117.194,90.631l-3.457,26.121H103.42L99.5,90.631h7.162q1.251,10.792,1.784,18.264.527-7.549,1.117-13.407l.471-4.857Z",
    transform: "translate(105.972 96.53)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3907",
    "data-name": "Tracciato 3907",
    d: "M124.464,106.21q0,3.934-.186,5.574a6.238,6.238,0,0,1-3.8,5.074,9.623,9.623,0,0,1-3.872.727,9.89,9.89,0,0,1-3.767-.686,6.286,6.286,0,0,1-3.9-5.043,55.584,55.584,0,0,1-.192-5.646v-4.471q0-3.934.186-5.574a6.241,6.241,0,0,1,3.8-5.074,9.623,9.623,0,0,1,3.872-.727,9.861,9.861,0,0,1,3.769.686,6.281,6.281,0,0,1,3.895,5.043,54.794,54.794,0,0,1,.194,5.646Zm-6.792-8.585a8.1,8.1,0,0,0-.2-2.331.8.8,0,0,0-.83-.508.927.927,0,0,0-.816.411,5.85,5.85,0,0,0-.281,2.429v12.2a11.85,11.85,0,0,0,.186,2.806.807.807,0,0,0,.863.533.835.835,0,0,0,.886-.613,12.842,12.842,0,0,0,.194-2.92Z",
    transform: "translate(115.829 96.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3908",
    "data-name": "Tracciato 3908",
    d: "M124.464,106.21q0,3.934-.186,5.574a6.238,6.238,0,0,1-3.8,5.074,9.623,9.623,0,0,1-3.872.727,9.89,9.89,0,0,1-3.767-.686,6.286,6.286,0,0,1-3.9-5.043,55.584,55.584,0,0,1-.192-5.646v-4.471q0-3.934.186-5.574a6.241,6.241,0,0,1,3.8-5.074,9.623,9.623,0,0,1,3.872-.727,9.861,9.861,0,0,1,3.769.686,6.281,6.281,0,0,1,3.895,5.043,54.794,54.794,0,0,1,.194,5.646Zm-6.792-8.585a8.1,8.1,0,0,0-.2-2.331.8.8,0,0,0-.83-.508.927.927,0,0,0-.816.411,5.85,5.85,0,0,0-.281,2.429v12.2a11.85,11.85,0,0,0,.186,2.806.807.807,0,0,0,.863.533.835.835,0,0,0,.886-.613,12.842,12.842,0,0,0,.194-2.92Z",
    transform: "translate(115.829 96.246)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3909",
    "data-name": "Tracciato 3909",
    d: "M117.811,90.631h4.808a36.681,36.681,0,0,1,6.509.372,4.478,4.478,0,0,1,2.775,1.9,8.59,8.59,0,0,1,1.074,4.863q0,3.048-.758,4.1a3.974,3.974,0,0,1-2.986,1.26,5.09,5.09,0,0,1,2.711,1.34,4.015,4.015,0,0,1,.863,1.541,24.506,24.506,0,0,1,.169,3.864v6.889h-6.309v-8.68a6.015,6.015,0,0,0-.33-2.6q-.331-.5-1.735-.5v11.777h-6.792ZM124.6,95.1v5.809a2.973,2.973,0,0,0,1.6-.316q.462-.313.461-2.04V97.117a2.176,2.176,0,0,0-.444-1.631A2.524,2.524,0,0,0,124.6,95.1",
    transform: "translate(125.479 96.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3910",
    "data-name": "Tracciato 3910",
    d: "M117.811,90.631h4.808a36.681,36.681,0,0,1,6.509.372,4.478,4.478,0,0,1,2.775,1.9,8.59,8.59,0,0,1,1.074,4.863q0,3.048-.758,4.1a3.974,3.974,0,0,1-2.986,1.26,5.09,5.09,0,0,1,2.711,1.34,4.015,4.015,0,0,1,.863,1.541,24.506,24.506,0,0,1,.169,3.864v6.889h-6.309v-8.68a6.015,6.015,0,0,0-.33-2.6q-.331-.5-1.735-.5v11.777h-6.792ZM124.6,95.1v5.809a2.973,2.973,0,0,0,1.6-.316q.462-.313.461-2.04V97.117a2.176,2.176,0,0,0-.444-1.631A2.524,2.524,0,0,0,124.6,95.1Z",
    transform: "translate(125.479 96.53)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3911",
    "data-name": "Tracciato 3911",
    d: "M129.7,90.631h5.082a31.582,31.582,0,0,1,6.656.452,5.116,5.116,0,0,1,2.637,1.483,4.7,4.7,0,0,1,1.13,2.3,34.745,34.745,0,0,1,.225,4.977v9.148a21.329,21.329,0,0,1-.33,4.7,3.524,3.524,0,0,1-1.154,1.857,4.788,4.788,0,0,1-2.032.935,18.367,18.367,0,0,1-3.647.266H129.7Zm6.792,4.469v17.184q1.468,0,1.807-.589a8.651,8.651,0,0,0,.339-3.2V98.342a13.456,13.456,0,0,0-.114-2.274,1.084,1.084,0,0,0-.516-.735,3.366,3.366,0,0,0-1.516-.233",
    transform: "translate(138.137 96.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3912",
    "data-name": "Tracciato 3912",
    d: "M129.7,90.631h5.082a31.582,31.582,0,0,1,6.656.452,5.116,5.116,0,0,1,2.637,1.483,4.7,4.7,0,0,1,1.13,2.3,34.745,34.745,0,0,1,.225,4.977v9.148a21.329,21.329,0,0,1-.33,4.7,3.524,3.524,0,0,1-1.154,1.857,4.788,4.788,0,0,1-2.032.935,18.367,18.367,0,0,1-3.647.266H129.7Zm6.792,4.469v17.184q1.468,0,1.807-.589a8.651,8.651,0,0,0,.339-3.2V98.342a13.456,13.456,0,0,0-.114-2.274,1.084,1.084,0,0,0-.516-.735A3.366,3.366,0,0,0,136.488,95.1Z",
    transform: "translate(138.137 96.53)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3913",
    "data-name": "Tracciato 3913",
    d: "M137.662,88.057H143.4l2.84,4.372h-3.275Zm8.793,31.437h-6.712V94.932h6.712Z",
    transform: "translate(146.622 93.788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3914",
    "data-name": "Tracciato 3914",
    d: "M137.662,88.057H143.4l2.84,4.372h-3.275Zm8.793,31.437h-6.712V94.932h6.712Z",
    transform: "translate(146.622 93.788)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3915",
    "data-name": "Tracciato 3915",
    d: "M149.888,99.336h-6.517a17.111,17.111,0,0,1,.58-5.018,5.527,5.527,0,0,1,2.381-2.765A8.432,8.432,0,0,1,151,90.365a9.194,9.194,0,0,1,3.583.646,5.962,5.962,0,0,1,2.435,1.8,7.875,7.875,0,0,1,1.324,2.493,15.276,15.276,0,0,1,.419,4.194v3.2a12.372,12.372,0,0,1-.4,3.5,4.564,4.564,0,0,1-1.759,2.323,5.2,5.2,0,0,1-3.178,1,3.885,3.885,0,0,1-3.533-1.854v2.806h-6.082V103.29h5.937q.031,1.484,1.066,1.483a.959.959,0,0,0,1.024-.653,13.722,13.722,0,0,0,.217-3.2V96.577a6.055,6.055,0,0,0-.2-1.927.784.784,0,0,0-.8-.494.9.9,0,0,0-.952.655,12.371,12.371,0,0,0-.211,2.945Zm0,17.7h-6.082v-5.227h6.082Z",
    transform: "translate(152.702 96.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3916",
    "data-name": "Tracciato 3916",
    d: "M149.888,99.336h-6.517a17.111,17.111,0,0,1,.58-5.018,5.527,5.527,0,0,1,2.381-2.765A8.432,8.432,0,0,1,151,90.365a9.194,9.194,0,0,1,3.583.646,5.962,5.962,0,0,1,2.435,1.8,7.875,7.875,0,0,1,1.324,2.493,15.276,15.276,0,0,1,.419,4.194v3.2a12.372,12.372,0,0,1-.4,3.5,4.564,4.564,0,0,1-1.759,2.323,5.2,5.2,0,0,1-3.178,1,3.885,3.885,0,0,1-3.533-1.854v2.806h-6.082V103.29h5.937q.031,1.484,1.066,1.483a.959.959,0,0,0,1.024-.653,13.722,13.722,0,0,0,.217-3.2V96.577a6.055,6.055,0,0,0-.2-1.927.784.784,0,0,0-.8-.494.9.9,0,0,0-.952.655,12.371,12.371,0,0,0-.211,2.945Zm0,17.7h-6.082v-5.227h6.082Z",
    transform: "translate(152.702 96.246)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 0.75
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailEnding);
export default __webpack_public_path__ + "static/media/fail-ending.d63a7127c0c4b5b7922308c29b33f739.svg";
export { ForwardRef as ReactComponent };